import { gql } from '@apollo/client';

export const GET_ALL_PRODUCT_FROM_CART = gql`
  query GetAllProductFromCart {
    getAllProductFromCart {
      products {
        product {
          id
          name

          siteIds
          shortDescription

          fullDescription

          instruction

          terms

          sorting
          image
          countries
          baseCurrencyId
          categoryId
          isAvailable
          createdAt
          updatedAt
          baseCurrency {
            id
            name
          }
          category {
            id
            name
            image
            sorting
            parentId
            createdAt
            updatedAt
            parent {
              id
              name
              image
              sorting
              parentId
              createdAt
              updatedAt
            }
            children {
              id
              name
              image
              sorting
              parentId
              createdAt
              updatedAt
            }
          }
          skus {
            id
            productId
            name

            value
            providerId
            isAvailable
            createdAt
            updatedAt
          }
          carts {
            id
            userId
            skuId
            quantity
          }
          preset {
            isPreset
            presetName
          }
        }
        total
        quantity
        skuId
        sku {
          id
          productId
          name

          value
          providerId
          isAvailable
          createdAt
          updatedAt
        }
        id
      }
      total
    }
  }
`;
